/**
 * Shared chart utility functions for the SOHAndRUL feature.
 */

/**
 * Convert a hex color string to rgba().
 * @param {string} hex  - e.g. "#6D72F6" or "#6DF"
 * @param {number} alpha - 0–1
 */
export function hexToRgba(hex, alpha = 1) {
  const normalized = hex.replace("#", "");
  const fullHex = normalized.length === 3
    ? normalized.split("").map((ch) => ch + ch).join("")
    : normalized;
  const bigint = parseInt(fullHex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/**
 * Compute a tooltip position that keeps the tooltip within the viewport.
 *
 * @param {number} clientX
 * @param {number} clientY
 * @param {number} tooltipW - tooltip width in px
 * @param {number} tooltipH - tooltip height in px
 * @returns {{ left: number, top: number }}
 */
export function smartTooltipPos(clientX, clientY, tooltipW = 215, tooltipH = 155) {
  const M  = 14;
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  let left = clientX + M;
  let top  = clientY + M;
  if (left + tooltipW > vw - 8) left = clientX - tooltipW - M;
  if (top  + tooltipH > vh - 8) top  = clientY - tooltipH - M;
  return { left: Math.max(8, left), top: Math.max(8, top) };
}
